import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProductRepository from "src/repository/ProductRepository";

export const product_document_list = createAsyncThunk('product_document_list', async (params) => {
  return await new ProductRepository().getProductDocumentList(params.filter, params.top, params.orderby);
});

export const product_images_list = createAsyncThunk('product_images_list', async (params) => {
  return await new ProductRepository().getProductDocumentImageList(params.filter, params.top, params.variantAssetSearchType);
});

export const alternative_product_by_variant_number_list = createAsyncThunk('product_alternative_data_list', async (params) => {
  return await new ProductRepository().getAlternativeProductByVariantNumber(params.ItemNum, params.orderBy, params.top, params.skip);
});

export const alternative_products_count = createAsyncThunk('product_alternative_products_count', async (params) => {
  return await new ProductRepository().getAlternativeProductCountByVariantNumber(params.ItemNum);
});

export const check_designs = createAsyncThunk('check_designs', async (params) => {
  return await new ProductRepository().checkDesignsExist(params);
});
export const get_Product_Manufacture_External_Heading = createAsyncThunk('get_Product_Manufacture_External_Heading', async (params) => {
  return await new ProductRepository().getProductManufactureExternalHeading(params);
});

const initialState = {
  documentData: {},
  imagesData: {},
  alternativeProductData: {},
  alternativeProductCount: 0,
  designHubData: {},
  productHeadingData: {}
};

const slice = createSlice({
  name: "ProductDetail",
  initialState: initialState,
  reducers: {
    clearAlternativeProductData: (state, action) => {
      state.alternativeProductData = initialState.alternativeProductData
    },
  },
  extraReducers: {
    [product_document_list.fulfilled]: (state, { payload }) => {
      state.documentData = payload;
      return state;
    },
    [product_document_list.rejected]: (state, { payload }) => {
    },
    [product_images_list.fulfilled]: (state, { payload }) => {
      state.imagesData = payload.Data;
      return state;
    },
    [alternative_product_by_variant_number_list.fulfilled]: (state, { payload }) => {
      state.alternativeProductData = payload;
      return state;
    },
    [alternative_products_count.fulfilled]: (state, { payload }) => {
      state.alternativeProductCount = payload;
      return state;
    },
    [product_images_list.rejected]: (state, { payload }) => {
    },
    [check_designs.fulfilled]: (state, { payload }) => {
      state.designHubData = payload;
      return state;
    },
    [get_Product_Manufacture_External_Heading.fulfilled]: (state, { payload }) => {
      state.productHeadingData = payload;
      return state;
    },

  },
});

export const { setProductDetail, clearAlternativeProductData } = slice.actions;

export default slice.reducer;
